import React, { useContext } from 'react';

import { EditableFieldsView, EditableFieldsContext } from '../context';

import { NameFieldDisplay, NameFieldEditComponent } from './NameField';
import { EmailFieldDisplay, EmailFieldEditComponent } from './EmailField';
import { AddressEditableField } from './AddressField';
import { FundRaisingField, FundRaisingEditComponent } from './FundRaisingField';
import { DefaultOrgField } from './DefaultOrgField';
import { CreateOrganizationField } from './CreateOrganizationField';
import { EditableField, FieldProps } from './utils';
import { PromotionalNotificationsField } from './PromotionalNotificationsField';
import { UserNameFieldDisplay } from './UserNameField';

const PersonalSettingsFields = () => {
    const { fieldToEdit } = useContext(EditableFieldsContext);
    return (
        <div>
            <EditableField<FieldProps>
                id="namefield"
                className="mb-8"
                editMode={Boolean(fieldToEdit)}
                isEditing={fieldToEdit === 'namefield'}
                FieldDisplayComponent={NameFieldDisplay}
                FieldEditComponent={NameFieldEditComponent}
            />
            <EditableField<FieldProps>
                id="usernamefield"
                className="mb-8"
                editMode={Boolean(fieldToEdit)}
                isEditing={fieldToEdit === 'username'}
                FieldDisplayComponent={UserNameFieldDisplay}
                FieldEditComponent={() => null}
            />
            <EditableField<FieldProps>
                id="emailfield"
                className="mb-8"
                editMode={Boolean(fieldToEdit)}
                isEditing={fieldToEdit === 'emailfield'}
                FieldDisplayComponent={EmailFieldDisplay}
                FieldEditComponent={EmailFieldEditComponent}
            />
            <AddressEditableField fieldToEdit={fieldToEdit} />
            <EditableField<FieldProps>
                id="fundraising-for"
                className="mb-8"
                editMode={Boolean(fieldToEdit)}
                isEditing={fieldToEdit === 'fundraising-for'}
                FieldDisplayComponent={FundRaisingField}
                FieldEditComponent={FundRaisingEditComponent}
            />
            <DefaultOrgField />
            <CreateOrganizationField editMode={Boolean(fieldToEdit)} />
        </div>
    );
};

export const PersonalSettingsContent = () => {
    return (
        <EditableFieldsView>
            <PersonalSettingsFields />
        </EditableFieldsView>
    );
};
